<template>
  <el-col class="menuLayout" id="leftMenu">
    <el-menu class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
             background-color="#ffffff" text-color="#333333" active-text-color="#FF7052"
             :unique-opened="true" :default-active="currentPagePath" :router="true">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>团意险管理</span>
        </template>
        <el-menu-item index="/wapPage/quotationManagement">报价单管理</el-menu-item>
        <el-menu-item index="/wapPage/orderManagement?insuranceIsGroup=4">订单管理</el-menu-item>
        <el-menu-item index="/wapPage/policyManagement?insuranceIsGroup=4">保单管理</el-menu-item>
        <el-submenu index="1-1">
          <template slot="title">
            <span class="correct">保单批改</span>
          </template>
          <el-menu-item index="/wapPage/personnelManagement?insuranceIsGroup=4">人员增减</el-menu-item>
          <el-menu-item index="/wapPage/correctingHistoryManagement?type=27">批改历史</el-menu-item>
        </el-submenu>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>雇主险管理</span>
        </template>
        <el-menu-item index="/wapPage/orderManagement?insuranceIsGroup=2">订单管理</el-menu-item>
        <el-menu-item index="/wapPage/policyManagement?insuranceIsGroup=2">保单管理</el-menu-item>
        <el-submenu index="1-1">
          <template slot="title">
            <span class="correct">保单批改</span>
          </template>
          <el-menu-item index="/wapPage/personnelManagement?insuranceIsGroup=2">人员增减</el-menu-item>
          <el-menu-item index="/wapPage/correctingHistoryManagement?type=20">批改历史</el-menu-item>
        </el-submenu>
      </el-submenu>
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>关税险管理</span>
        </template>
        <el-menu-item index="/wapPage/dutyInsurance/offerTesting">保费测算</el-menu-item>
        <el-menu-item index="/wapPage/dutyInsurance/orderManagement">订单管理</el-menu-item>
        <el-menu-item index="/wapPage/dutyInsurance/insuranceManagement">保单管理</el-menu-item>
        <el-menu-item index="/wapPage/dutyInsurance/myInvitation">我的邀请</el-menu-item>
        <!--<el-menu-item @click="onDutyInsurance(0)">保费测算</el-menu-item>
        <el-menu-item @click="onDutyInsurance(1)">订单管理</el-menu-item>
        <el-menu-item @click="onDutyInsurance(2)">保单管理</el-menu-item>
        <el-menu-item @click="onDutyInsurance(3)">我的邀请</el-menu-item>-->
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>车险管理</span>
        </template>
        <el-menu-item index="/wapPage/quotationManagement?insType=5">报价单管理</el-menu-item>
        <el-menu-item index="/wapPage/orderManagement?insuranceIsGroup=5">订单管理</el-menu-item>
      </el-submenu>
    </el-menu>
  </el-col>
</template>

<script>

    export default {
      name: "leftMenu",
      data(){
        return{
          currentPagePath: '/wapPage',
        }
      },
      methods:{
        handleOpen(key, keyPath) {
          //console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
          //console.log(key, keyPath);
        },
        onDutyInsurance(type) {
          let protocol = document.location.protocol;
          let host = 'http:' == protocol ? `http://xbyf.xiaobaibao.com`:`https://xbyf.xiaobaibao.com`;
          switch (type) {
            case 0:{
              return window.open(`${host}/old/html/dutyInsurance/offerTesting.html`);
            }
            case 1:{
              return window.open(`${host}/old/html/dutyInsurance/orderManagement.html`);
            }
            case 2:{
              return window.open(`${host}/old/html/dutyInsurance/insuranceManagement.html`);
            }
            case 3:{
                // this.$router.push({name: `myInvitation`});
              return window.open(`${host}/old/html/dutyInsurance/myInvitation.html`);
            }
          }
        },
      },
      mounted() {
        // that.current = that.$route.name;
        console.log(this.$route.name)
      }
    }
</script>

<style scoped>
  .menuLayout{
    width: 180px;
    padding-right: 10px;
    margin-bottom: 10px;
    display: inline-block;
  }

  .el-menu-vertical-demo {
    border: none;
  }

  .el-submenu .el-menu-item{
    min-width: 100%;
  }

  .el-submenu .correct{
    width: 100%;
    display: inline-block;
  }

</style>



// WEBPACK FOOTER //
// src/components/assembly/leftMenu.vue